export const BODY_MAX_WIDTH = '540px'
export const HEADER_HEIGHT = '64px'
